import { html, View } from 'rune-ts';
import { NewCreatorProductData } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { createCreatorProductStore } from '@services/MarppleShopStudio/widget/CreatorProduct/core/store/createStore.ts';
import klass from './Form.module.scss';
import { ButtonAction } from '@services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { MainInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/MainInfoSection.ts';
import { SalesInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/SalesInfoSection.ts';
import { StockAndOptionSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/StockAndOptionSection.ts';
import { ProducingInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/ProducingInfoSection.ts';
import { DetailInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/DetailInfoSection.ts';

export class NewForm extends View<NewCreatorProductData> {
  private store = createCreatorProductStore(this.data.mode);

  private buttonTempSave = new ButtonAction({
    klass: klass.button_temp_save,
    size: 'regular',
    label: '임시저장',
    type: 'style_disabled',
  });

  private buttonSave = new ButtonAction({
    klass: klass.button_save,
    size: 'regular',
    label: '상품 등록하기',
    type: 'style_disabled',
  });

  protected override template() {
    return html`
      <div class="${klass.root}">
        <section class="${klass.button_section}">${this.buttonTempSave} ${this.buttonSave}</section>
        <div class="${klass.section_container}">
          ${new MainInfoSection({
            store: this.store,
            products_memberships: this.data.products_memberships ?? [],
            mpsCategories: this.data.mpsCategories,
          })}
          ${new SalesInfoSection({
            store: this.store,
          })}
          ${new StockAndOptionSection({
            store: this.store,
          })}
          ${new ProducingInfoSection({
            store: this.store,
          })}
          ${new DetailInfoSection({
            store: this.store,
          })}
        </div>
        <section class="${klass.button_section}">${this.buttonTempSave} ${this.buttonSave}</section>
      </div>
    `;
  }

  override onRender() {
    this.buttonTempSave.addEventListener('click', () => {
      console.log('buttonTempSave');
    });

    this.buttonSave.addEventListener('click', () => {
      console.log('buttonSubmit');
    });
  }
}
